import axios from 'axios';
import { MDBTableEditor } from 'mdb-react-table-editor';
import {
    MDBAlert,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBContainer,
    MDBDatepicker,MDBSelect,MDBInputGroup,MDBTableHead,
    MDBInput, MDBLightbox, MDBLightboxItem,
    MDBSpinner,
    MDBTable
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CategoryFormModal from "./../category/CategoryFormModal";
import { deleteHandle, fetchCompanyMap, fetchDocumentMap } from './../utils/Common';
import { GeographyContext } from '../context/GeographyProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
import { DomainContext } from '../context/DomainProvider';
import { CategoryContext } from '../context/CategoryContext';

const ReceiptTransFormation = ({ receipt,setShowAlertFromUnProcesed,
    receipts,  
    setActiveTab,
    setReceipts,    
    firm,
    moveReceiptToProcessed,
    setShowAlert,setAlertMessage,setIsReceiptToBeProcessed,
    activeTab,setEntitiesCreated }) => {
    const {setIsNewReceipt, isUploading,  setDocumentsMap,setCompaniesMap } = useContext(MiscContext);
    const {selectDomains} = useContext(DomainContext);
    const { location,ipAddress} = useContext(GeographyContext);
    const {tokenLoaded,images,setCompanyNames, companyNames} = useContext(UserProfileContext);
    const {selectCategories} = useContext(CategoryContext)
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const [everyRowHasCategory, setEveryRowHasCategory] = useState(false);
   
    const[companyToMove, setCompanyToMove] = useState("");
    
    const didFetchRef = useRef(false);

const [lReceipt, setLReceipt] = useState(receipt);
   
    const [alertColor, setAlertColor] = useState('');
 
    const [items,setItems] = useState(lReceipt.receiptTranslated ? lReceipt.receiptTranslated.items : []);

    // Find all unique keys in items
    const allKeys = items.reduce((keys, item) => {
        return [...keys, ...Object.keys(item)];
    }, []);
    const [files, setFiles] = useState([]);
    const [company, setCompany] = useState(lReceipt.receiptTranslated && lReceipt.receiptTranslated.company);
    const [originalName, setOriginalName] = useState();
    const [dateOfPurchase, setDateOfPurchase] = useState(lReceipt.receiptTranslated && lReceipt.receiptTranslated.date);
    const [subTotal, setSubTotal] = useState(lReceipt.receiptTranslated && (lReceipt.receiptTranslated["subTotal"]));
    const [tax, setTax] = useState(lReceipt.receiptTranslated && lReceipt.receiptTranslated["tax"] ? lReceipt.receiptTranslated["tax"] : 0);
    const [tip, setTip] = useState(lReceipt.receiptTranslated && lReceipt.receiptTranslated["tip"] ? lReceipt.receiptTranslated["tip"] : 0);

    const [total, setTotal] = useState(lReceipt.receiptTranslated && lReceipt.receiptTranslated.total);
    const [selectedImage, setSelectedImage] = useState(null);
    const [showLightbox, setShowLightbox] = useState(false);
    

    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const callModalToAdd = () => {
        setShowCategoryModal(true);
    } 
    const imagesObj = images?.reduce((obj, image) => {
        obj[image.name] = image.url;
        return obj;
    }, {});

    const imageNamesToIds = images?.reduce((obj, image) => {
        obj[image.name] = image.id;
        return obj;
    }, {});


  

  

    const [tableData, setTableData] = useState(() => {
        const filteredCategories = selectCategories.filter(cat => cat.text !== 'pricing');
        const sortedCategories = [...filteredCategories].sort((a, b) => a.text.localeCompare(b.text));


        const rows = items?.map(item => ({
            id: item.id,
            name: item.name,
            price: item.price,
            weight: item.weight || '',
            qty: item?.qty?.replace(/[^\d.]/g, '') || 0,
            originalName: item.originalName || item.name || '',
            Category: sortedCategories?.find(cat => cat.value === item.categoryId)?.text || sortedCategories?.[0]?.text || '',
            Domain: selectDomains?.[0]?.text || '',
            Images: [],
        }));
    
        // Define columns
        const columns = [
            { label: 'ID', field: 'id', width: 10 },
            { label: '*Name', field: 'name', width: 200 },
            { label: '*Quantity', field: 'qty', width: 60, inputType: "number" },
            {
                label: `Weight (${lReceipt?.metrics})`, 
                field: 'weight', 
                width: 60, 
                inputType: "number",
                formatter: (rowData) => {
                    const weight = rowData.weight;
                    return weight === undefined || weight === null ? '' : weight;
                }
            },
            {
                label: `*Price (${lReceipt?.currency})`, field: 'price', width: 100, inputType: "number",
                formatter: (rowData) => {
                    const price = parseFloat(rowData.price);
                    const qty = parseFloat(rowData.qty);
                    return isNaN(price) || isNaN(qty) || qty === 0 ? '-' : (price / qty).toFixed(2);
                }
            },
            { label: '*Original Name', field: 'originalName', width: 200 },
            {
                label: '*Domain', field: 'Domain', width: 200,
                options: selectDomains?.map(item => item.text),
                defaultValue: selectDomains?.[0]?.text,
                inputType: 'select'
            },
            {
                label: '*Category', field: 'Category', width: 200,
                options: sortedCategories?.map(cat => cat.text),
                defaultValue: sortedCategories?.[0]?.text,
                inputType: 'select'
            },
          
            {
                label: 'Images', field: 'Images', width: 200,
                options: Object.keys(imagesObj).length > 0 ? Object.keys(imagesObj) : ['NA ? Create'],
                inputType: 'select'
            }
        ];
    
        return { columns, rows };
    });
    
    useEffect(() => {
        const sortedCategories = [...selectCategories].sort((a, b) => a.text.localeCompare(b.text));
    
        const updatedColumns = tableData.columns?.map(column => {
            if (column.field === 'Category') {
                return {
                    ...column,
                    options: sortedCategories.length > 0 ? sortedCategories.map(item => item.text) : ['NA ? Create'],
                };
            }
            return column;
        });
    
        setTableData({ ...tableData, columns: updatedColumns });
    }, [selectCategories]); // Do not add tableData in dependency array
    
      

 
function getDomainValue(domainText) {
    const domainObj = selectDomains.find(item => item.text === domainText);
    return domainObj ? domainObj.value : domainText;
}

// Helper function to get the value for a given category text
function getCategoryValue(categoryText) {
   // const filteredCategories = selectCategories.filter(item => item.text !== 'pricing');  
    const categoryObj = selectCategories.find(item => item.text === categoryText);
    return categoryObj ? categoryObj.value : categoryText;
}
function createCSVContent(rows) {
    let shouldReturnNull = false; // Flag to indicate if null should be returned
    
    if (!rows.length) return '';

    const allKeys = rows.reduce((keys, row) => {
        return [...keys, ...Object.keys(row).filter(key => key !== 'id')];
    }, []);
    const uniqueKeys = [...new Set(allKeys)];

    // Add 'DomainId' and 'CategoryId' to headers
    const headers = [...uniqueKeys, 'DomainId', 'CategoryId', 'originalName', 'dateOfPurchase', 'company', 'subTotal', 'total','tax','tip'];

    const csvContent = rows.map((row, index) => {
        const originalItem = receipt.receiptTranslated.items[row.id - 1]?.name;

        const rowWithAdditionalData = {
            ...row,
            DomainId: getDomainValue(row.Domain), // Fetch and set Domain ID
            CategoryId: getCategoryValue(row.Category), // Fetch and set Category ID
            Domain: row.Domain, 
            Category: row.Category, 
            Images: imageNamesToIds[row.Images],
            originalName: originalName || row.originalName,
            originalCompanyName: originalItem || '',
            dateOfPurchase: dateOfPurchase,
            company: company,
            subTotal: subTotal?.replace('$', ''),
            total: total?.replace('$', ''),
            //tax: tax?.replace('$', '') ,
            tax: typeof tax === 'string' ? tax.replace('$', '') : String(tax),

            tip: typeof tip === 'string' ? tip.replace('$', '') : String(tip),
            price: typeof row.price === 'string' ? row.price.replace('$', '') : row.price,
            qty: typeof row.qty === 'string' ? row.qty.replace(/[^\d.]/g, '') : (row.qty != null ? String(row.qty).replace(/[^\d.]/g, '') : ''), // Convert to string if not null or 
            weight: typeof row.weight === 'string' ? row.weight.replace(/[^\d.]/g, '') : (row.weight != null ? String(row.weight).replace(/[^\d.]/g, '') : ''), // Convert to string if not null or undefined
        };

        const invalidFields = [];

        // Check if price is not valid
        if (!rowWithAdditionalData?.price || isNaN(parseFloat(rowWithAdditionalData?.price))) {
            invalidFields.push('Price');
        }

        if (!rowWithAdditionalData?.subTotal || isNaN(parseFloat(rowWithAdditionalData?.subTotal))) {
            invalidFields.push('Price');
        }

        if (!rowWithAdditionalData?.total || isNaN(parseFloat(rowWithAdditionalData?.total))) {
            invalidFields.push('Total');
        }
        // Check if qty is not valid
        if (!rowWithAdditionalData?.qty || isNaN(parseFloat(rowWithAdditionalData?.qty))) {
            invalidFields.push('Qty');
        }

        // Check if tax is not valid
        if (!rowWithAdditionalData?.tax || isNaN(parseFloat(rowWithAdditionalData?.tax))) {
            invalidFields.push('Tax');
        }

        // Check if tip is not valid
        if (!rowWithAdditionalData?.tip || isNaN(parseFloat(rowWithAdditionalData?.tip))) {
            invalidFields.push('Tip');
        }

        // Show alert if any invalid fields found
        if (invalidFields.length > 0) {
            const alertMessage = `Invalid ${invalidFields?.join(', ')} found `;
            setAlertMessage(alertMessage);
            setShowAlert(true);
            shouldReturnNull = true;
        }

        return headers.map(header => JSON.stringify(rowWithAdditionalData[header] || '')).join(',');
    }).join('\n');

    if (shouldReturnNull) return null; // Return null if the flag is set

    const csv = headers.join(',') + '\n' + csvContent;

    return csv;
}


useEffect(() => {
    if (files.length > 0 && !didFetchRef.current) {
        didFetchRef.current = true;
        handleUpload(files);
    }
}, [files,lReceipt]);




    function csvStringToFile(csvString, filename) {
        const blob = new Blob([csvString], { type: 'text/csv' });
        return new File([blob], filename, { type: 'text/csv' });
    }


    const handleSave = (company) => {
        const csvContent = createCSVContent(tableData.rows);
        setCompanyToMove(company);
      if(csvContent){
        const csvFile = csvStringToFile(csvContent, 'data.csv');

        setFiles(prevFiles => {
          
            const updatedFiles = [...prevFiles, csvFile];
           // handleUpload(updatedFiles);
            return updatedFiles;
        });
           }
    }




    const handleUpload = async (filesToUpload) => {
        const formData = new FormData();
        filesToUpload.forEach(file => {
            const formKey = file.name.toLowerCase().endsWith('.csv') ? 'csv' : 'images';
            formData.append(formKey, file);
        });
    
        try {
            const url = buildUploadUrl(baseUrl, receipt.id, location, ipAddress);
            const response = await axios.post(url, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                withCredentials: true,
            });
    
            if (response.status === 200 || response.status === 201) {
                await processSuccessfulUpload();
                removeEntriesFromDocumentsMap(companyToMove);
            } else {
                console.error("Upload failed:", response.status);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    };
    
    const buildUploadUrl = (baseUrl, receiptId, location, ipAddress) => {
        let latLngQuery = location 
            ? `?latitude=${location.latitude}&longitude=${location.longitude}`
            : `?ipAddress=${ipAddress}`;
        return `${baseUrl}/upload/files/receipt/${receiptId}${latLngQuery}`;
    };
    
    const processSuccessfulUpload = async () => {
        setEntitiesCreated(true);
        setAlertMessage('Saved');
        setShowAlert(true);
    
        const updatedReceipts = receipts.filter(receipt => receipt.id !== activeTab);
        if (updatedReceipts.length > 0) {
           await moveCompanyToProcessed();
           setLReceipt(updatedReceipts[0]);
           didFetchRef.current = false;
            setReceipts(updatedReceipts);
            setActiveReceiptAndItems(updatedReceipts[1]);
        } else {
            clearReceipts();
        }
    };
    
    const setActiveReceiptAndItems = (receipt) => {
        setLReceipt(receipt);
        setItems(receipt.receiptTranslated ? receipt.receiptTranslated.items : []);
        setActiveTab(receipt.id);
    };
    
    const clearReceipts = () => {
        setActiveTab(null);
        setIsReceiptToBeProcessed(false);
        setReceipts([]);
        setItems([]);
    };
    


    
    
    

    const moveCompanyToProcessed = async () => {
        try {
          await fetchDocumentMap(setDocumentsMap, tokenLoaded,);
          await fetchCompanyMap(setCompaniesMap, tokenLoaded);
        } catch (error) {
          console.error("Error moving company to processed: ", error);
        }
      };
      
    
      const removeEntriesFromDocumentsMap = (companyName) => {
        setDocumentsMap(prevDocumentsMap => {
            const newDocumentsMap = { ...prevDocumentsMap };
            const lowerCaseCompanyName = companyName.toLowerCase();
    
            // Find the key in a case-insensitive manner
            const keyToRemove = Object.keys(newDocumentsMap.receiptsUnProcessed)
                .find(key => key.toLowerCase() === lowerCaseCompanyName);
    
            if (keyToRemove) {
                delete newDocumentsMap.receiptsUnProcessed[keyToRemove];
            }
    
            return newDocumentsMap;
        });
    };
    
    


    const checkEveryRowHasCategory = () => {
        const result = tableData.rows.every(row => row.Category && row.Category.trim() !== '');
        setEveryRowHasCategory(result);
        setIsAlertVisible(!result);
    };

    useEffect(() => {
        checkEveryRowHasCategory();
    }, [tableData]);
  

  

  
   
    const handleValueChange = (modifiedData) => {
        modifiedData.forEach((modifiedRow, index) => {
            // Calculate the new price per quantity if both price and quantity are updated
            if (modifiedRow.price && modifiedRow.qty) {
                const newPrice = parseFloat(modifiedRow.price);
                const newQty = parseFloat(modifiedRow.qty);
                if (!isNaN(newPrice) && !isNaN(newQty) && newQty !== 0) {
                    modifiedData[index].price = newPrice ;
                }
            }
            
            modifiedData.forEach(modifiedRow => {
                if (modifiedRow.Images) {
                    const image = images.find(img => img.name === modifiedRow.Images);
                    setSelectedImage(image);
                    setShowLightbox(true);
                }
               
            });
            
            // Update the table data state
            setTableData((prevData) => ({
                ...prevData,
                rows: modifiedData,
            }));
        });
    };
    
    const [options, setOptions] = useState([]);
   
    useEffect(() => {
        const updatedOptions = companyNames.map(name => ({ text: name, value: name }));       
        setOptions(updatedOptions);
    }, [company, companyNames]); // Depend on company and companyNames to refresh options.
    
    const handleSelectChange = (event) => {
        const newValue = event?.target?.value || event?.value; // Handle different possible structures.
        setCompany(newValue);
    
        if (!companyNames.includes(newValue)) {
            setCompanyNames(prev => [...prev, newValue]);
        }
    };

 


    return (
     
          <section>
           {isUploading &&
              <MDBSpinner className='mx-2' color='warning'>
                <span className='visually-hidden'>Loading...</span>
              </MDBSpinner>}
              <MDBCard>
  <MDBCardBody>
    <MDBTable className="text-nowrap">
      <MDBTableHead>
        <tr className="d-flex flex-column flex-md-row">
          <td className="col-12 col-md-2">
            <MDBInputGroup className="mb-3">
            <div className="input-tooltip-wrapper">
                    <MDBInput
                      className='text-lowercase'
                      size='sm'
                      type='text'
                      label='*Company'
                      value={company}
                      onChange={e => setCompany(e.target.value)}
                    />
                    <div className="input-tooltip">
                      {company}
                    </div>
                  </div>
              <MDBSelect
                search          
                data={options}
                noResultsText='please type the required company in the left input'
                preventFirstSelection={true}
                defaultValue={company}
                value={company}
                label="*Select a Company"
                onChange={handleSelectChange}
              />
            </MDBInputGroup>
          </td>
          <td className="col-12 col-md-2">
            <div className="form-group mb-3">
              <MDBDatepicker 
                className='text-lowercase'
                format='mm/dd/yyyy'
                label='* Date Of Purchase'
                size='sm'
                disableFuture={true}
                icon='fas fa-calendar'
                defaultValue={dateOfPurchase}
                onChange={(selectedDate) => setDateOfPurchase(selectedDate)}
              />
            </div>
          </td>
          <td className="col-12 col-md-2">
            <div className="form-group mb-3">
              <MDBInput
                className='text-lowercase'
                size='sm'
                label='*Sub Total'
                type='text'
                defaultValue={subTotal===0 ? lReceipt.receiptTranslated["subtotal"] : subTotal}
                onChange={e => setSubTotal(e.target.value)}
              />
            </div>
          </td>
          <td className="col-12 col-md-2">
            <div className="form-group mb-3">
              <MDBInput
                className='text-lowercase'
                size='sm'
                label='*Total'
                type='text'
                defaultValue={total===0? lReceipt.receiptTranslated["subtotal"] : total}
                onChange={e => setTotal(e.target.value)}
              />
            </div>
          </td>
          <td className="col-12 col-md-2">
            <div className="form-group mb-3">
              <MDBInput
                className='text-lowercase'
                size='sm'
                label='Tax'
                type='text'
                defaultValue={tax}
                onChange={e => setTax(e.target.value)}
              />
            </div>
          </td>
          <td className="col-12 col-md-2">
            <div className="form-group mb-3">
              <MDBInput
                className='text-lowercase'
                size='sm'
                label='Tip'
                type='text'
                defaultValue={tip}
                onChange={e => setTip(e.target.value)}
              />
            </div>
          </td>
        </tr>
      </MDBTableHead>
    </MDBTable>

    <MDBTableEditor 
      align="middle" 
      striped 
      search 
      maxHeight='520px' 
      actionPosition='start' 
      borderColor='red'
      hover={true}  
      mode='modal' 
      fixedHeader 
      bordered
      sortField='name' 
      className='text-lowercase text-primary text-wrap' 
      data={tableData}
      onAdd={(newRow) => setTableData({ ...tableData, rows: [...tableData.rows, newRow] })}
      onModify={(modifiedData) => handleValueChange(modifiedData)}
      onDelete={(id) => setTableData({ ...tableData, rows: tableData.rows.filter((row, i) => i !== id) })} 
      rowsText='Rows' 
    />
  </MDBCardBody>
</MDBCard>



    <MDBContainer className='text-center mt-4'>
        <div className="d-flex justify-content-center align-items-center text-center d-grid gap-2 ">
        <MDBBtn
 disabled={
    !everyRowHasCategory ||
    tableData?.rows.some(
        row => {
            // Check if row.price is a string before calling string methods
            const formattedPrice = typeof row.price === 'string' ? row.price.trim().replace('$', '') : row.price;
            // Convert formattedPrice to a number
            const priceAsNumber = parseFloat(formattedPrice);
            // Check if priceAsNumber is NaN or less than or equal to 0
            return (
                (!row.name || row.name.trim() === "") ||
                (isNaN(priceAsNumber) || priceAsNumber <= 0)
            );
        }
    ) ||
    !dateOfPurchase ||
    !company || !total || !subTotal ||typeof qty === 'string'
}
  onClick={()=> handleSave(company)} 
>
  Save
</MDBBtn>



            <MDBBtn onClick={() => callModalToAdd()}>ADD A Category</MDBBtn>
            {showLightbox && selectedImage && (
                <MDBLightbox className='badge badge-primary p-3 rounded-4' onClose={() => setShowLightbox(false)}>
                    <MDBLightboxItem
                        zoomLevel={0.25}
                        src={selectedImage.thumbnail ? selectedImage.thumbnail : "preview"}
                        fullscreenSrc={selectedImage.url}
                        onClose={() => setShowLightbox(false)}
                    /><p className='text-uppercase'>
                    preview</p>
                </MDBLightbox>
            )}
            <MDBBtn color='success' onClick={() => deleteHandle(lReceipt.id, setAlertColor,setShowAlert,setAlertMessage,receipts,setReceipts,setActiveTab,setIsNewReceipt,setIsReceiptToBeProcessed,moveCompanyToProcessed,tokenLoaded)}>Scan again?</MDBBtn>
        </div>

        <MDBAlert open={isAlertVisible} className='mt-3 w-100' color='primary' hidden={isAlertVisible}>
            Please select a category for all rows
        </MDBAlert>
    </MDBContainer>
    <CategoryFormModal 
             baseUrl={baseUrl}             
             setShowCategoryModal={setShowCategoryModal}
             showCategoryModal={showCategoryModal}
             domains={selectDomains}
            
             firm={firm}
           
        /> 
</section>
    );
}

ReceiptTransFormation.propTypes = {
    setShowAlert: PropTypes.func,  
    moveReceiptToProcessed: PropTypes.func,
    setAlertMessage: PropTypes.func,
    receipt: PropTypes.object,
    receipts: PropTypes.array,
    setActiveTab: PropTypes.func,
    setReceipts: PropTypes.func,
    activeTab: PropTypes.string,
    setEntitiesCreated: PropTypes.func,
    firm: PropTypes.string,
    setIsReceiptToBeProcessed: PropTypes.func,
    setShowAlertFromUnProcesed: PropTypes.func,
};

export default ReceiptTransFormation;
